var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHasSharePermit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5,
    r: 3,
    fill: "#949AA4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62389 9.04837C8.4206 9.01653 8.21223 9 8 9C5.79086 9 4 10.7909 4 13V14H12V13C12 12.7878 11.9835 12.5794 11.9516 12.3761L8.62389 9.04837Z",
    fill: "#949AA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7068 10.0726L14.6655 8.11398L13.9584 7.40688L11.9997 9.36554L10.9271 8.29289L10.22 9L11.2926 10.0726L11.2925 10.0728L11.9996 10.7799L11.9997 10.7798L11.9999 10.7799L12.707 10.0728L12.7068 10.0726Z",
    fill: "#949AA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHasSharePermit);
export default __webpack_public_path__ + "static/media/HasSharePermit.3e6f3bb12eeff270085996596919c75b.svg";
export { ForwardRef as ReactComponent };